import Validatable from '@/validator/Validatable';

interface IAdvancedReportDefinition {
  breakdown: string;
  format: string;
  dates: {
    reportForMonth: string;
    reportForYear: string;
    mode: string;
    date_range: string;
  };
  defaultReportOutputFormat: string;
  timezone: string;
}

export default class AdvancedReport extends Validatable {
  reportType: string;
  definition: IAdvancedReportDefinition;
  emails: string[];

  constructor(id = -1, reportType, definition, emails = []) {
    super();
    this.id = id;
    this.reportType = reportType;
    this.definition = definition;
    this.emails = emails;
  }

  get month() {
    return this.definition.dates != null && this.definition.dates.reportForMonth !== ''
      ? this.definition.dates.reportForMonth
      : '';
  }

  get year() {
    return this.definition.dates != null && this.definition.dates.reportForYear !== ''
      ? this.definition.dates.reportForYear
      : '';
  }

  static validatorCreateRules() {
    return {
      reportType: 'required',
      definition: 'required',
    };
  }
}
